import { Component, OnDestroy, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { EntryGroupService } from '../../../../services/accounting/entry-group.service';
import { NotyService } from '../../../../services/common/noty.service';
import { HttpClientService } from '../../../../services/common/http-client.service';
import { UserService } from '../../../../services/users/user.service';

@Component({
  selector: 'app-entry-group-index',
  templateUrl: './entry-group-index.component.html',
  styleUrls: ['./entry-group-index.component.scss']
})

export class EntryGroupIndexComponent implements OnInit, OnDestroy {

  count: number;

  entryGroups: Array<any> = [];

  entryGroupTypes: Array<any> = [];

  latestEntryGroupId: number;

  searchParams: any = {
    page: 1,
    commit: "filter",
    parents_only: true
  }

  searchOptions: any = {
    per_page: 20,
    entry_group_types: []
  }

  searching: boolean = false;

  sidebarMaximized: boolean = false;

  sidebarOpen: boolean = false;

  /**
   * Subscription to router events to catch page changes and matter id changes in the URL
   * @type {Subscription}
  */
  routerEventsSubscription: Subscription;
  componentDestroyed: boolean = false;
  sidebarScrollTimeouts: Array<any> = [];

  constructor(
    private httpClientService: HttpClientService,
    private entryGroupService: EntryGroupService,
    private notyService: NotyService,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService){
    this.routerEventsSubscription = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      if (this.componentDestroyed) return;
      this.initialize();
    });
  }

  ngOnInit(): void {
    if(this.userService.navbarComponent){
      this.userService.navbarComponent.setAccountingMenu();
    }
    this.entryGroupService.searchOptions()
      .then(response_json => {
        if (this.componentDestroyed) return;
        this.searchOptions = response_json;
        this.initialize();
      });    
  }

  ngOnDestroy() {
    this.componentDestroyed = true;
    if (this.routerEventsSubscription) this.routerEventsSubscription.unsubscribe();
    for (let timeout of this.sidebarScrollTimeouts) clearTimeout(timeout);
    this.sidebarScrollTimeouts = [];
  }

  ngAfterViewInit() {
    this.sidebarScrollTimeouts.push(setTimeout(() => {
      if (this.componentDestroyed) return;
      this.content_sidebar_scroll();
    }, 500));
    this.sidebarScrollTimeouts.push(setTimeout(() => {
      if (this.componentDestroyed) return;
      this.content_sidebar_scroll();
    }, 5000));
  }

  @HostListener('window:scroll', ['$event'])
   window_scroll(event: Event) {
    this.content_sidebar_scroll();
  }

  @HostListener('window:resize', ['$event'])
   window_resize(event: Event) {
    this.content_sidebar_scroll();
  }

  clearSearch() {
    this.router.navigate(['.'], { relativeTo: this.route, queryParams: {} });
    this.searchParams = {
      page: 1,
      per_page: 50,
      commit: "filter"
    }
    this.search();
  }

  initialize() {
    if (this.componentDestroyed) return;
    Object.assign(this.searchParams, this.route.snapshot.queryParams);
    this.search()
  }

  search(pageEvent: any = null, isSearching: boolean | null = false) {
    if (this.componentDestroyed) return;
    if (isSearching)
      this.searching = true;
    if (pageEvent) this.searchParams.page = pageEvent.page;
    this.entryGroupService.index(this.searchParams).then(response_json => {
      if (this.componentDestroyed) return;
      console.log("entry grops response", response_json);
      ({
        entry_groups: this.entryGroups, 
        count: this.count,  
        per_page: this.searchParams.per_page, 
        entry_group_types: this.entryGroupTypes,
        last_entry_group_id: this.latestEntryGroupId
      } = response_json);
      if (isSearching)
        this.searching = false;
      let newPageUrl: string = this.httpClientService.buildNewPageUrl(this.entryGroupService.url, this.searchParams);
      if(window.location.href != newPageUrl)
        this.httpClientService.setNewPageUrl(newPageUrl);
    }).catch(() =>{
      if (this.componentDestroyed) return;
      this.notyService.notify('Error loading entry groups', 'error');
    })
  }

  content_sidebar_scroll() {
    var content_main = document.getElementById('content-main');
    var content_sidebar = document.getElementById('content-sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 20;
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 20;
      }
      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }
}
